export const applyVintageMode = async (canvas, ctx, setMessage, language) => {
  // 진행 상황 업데이트
  setMessage(language === 'KR' ? '빈티지 모드 적용 중 (1/3) - 색상 조정...' : 'Applying Vintage Mode (1/3) - Adjusting colors...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  // 빈티지 모드 효과 적용
  // 1. 색상 조정 (따뜻한 색감, 세피아 효과)
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  for (let i = 0; i < data.length; i += 4) {
    // 빈티지/세피아 효과
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    
    // 세피아 색상으로 변환
    data[i] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
    data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
    data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 색상 페이드 및 빈티지 색감
  setMessage(language === 'KR' ? '빈티지 모드 적용 중 (2/3) - 빈티지 효과 적용...' : 'Applying Vintage Mode (2/3) - Adding vintage effect...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const fadeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const fadePixels = fadeData.data;
  
  // 색상 페이드 효과
  for (let i = 0; i < fadePixels.length; i += 4) {
    // 약간의 페이드 효과 추가
    fadePixels[i] = Math.min(255, fadePixels[i] * 0.9 + 40);
    fadePixels[i + 1] = Math.min(255, fadePixels[i + 1] * 0.9 + 20);
    fadePixels[i + 2] = Math.min(255, fadePixels[i + 2] * 0.9 + 10);
  }
  
  ctx.putImageData(fadeData, 0, 0);
  
  // 3. 비네팅 및 그레인 효과 추가
  setMessage(language === 'KR' ? '빈티지 모드 적용 중 (3/3) - 비네팅 효과 추가...' : 'Applying Vintage Mode (3/3) - Adding vignette...');
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const vignetteData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const vignettePixels = vignetteData.data;
  
  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;
  const maxDistance = Math.sqrt(centerX * centerX + centerY * centerY);
  
  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      // 비네팅 효과
      const dx = x - centerX;
      const dy = y - centerY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      
      // 거리에 따른 비네팅 강도 계산 (강한 비네팅)
      const strength = 0.6 + 0.4 * Math.min(1, Math.max(0, 1 - distance / maxDistance));
      
      // 픽셀 값 조정
      for (let c = 0; c < 3; c++) {
        vignettePixels[pos + c] = Math.min(255, Math.max(0, vignettePixels[pos + c] * strength));
      }
      
      // 랜덤 그레인 추가
      if (Math.random() > 0.95) { // 5% 확률로 그레인 적용
        const grainAmount = (Math.random() - 0.5) * 40; // -20에서 20 사이의 그레인 강도
        
        for (let c = 0; c < 3; c++) {
          vignettePixels[pos + c] = Math.min(255, Math.max(0, vignettePixels[pos + c] + grainAmount));
        }
      }
    }
  }
  
  ctx.putImageData(vignetteData, 0, 0);
  
  // 처리 완료
  setMessage(language === 'KR' ? '빈티지 모드 적용 완료!' : 'Vintage Mode applied!');
};